export default __webpack_public_path__ + "assets/event.9b026336.svg";